<template>
  <SubHeader
    title="Liste des Caracterisations"
    :breads="[{ name: 'Caracterisations' }]"
    :action="{}"
  />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <div
            class="row justify-content-between align-items-center flex-grow-1"
          >
            <div class="col-12 col-md">
              <div class="d-flex justify-content-between align-items-center">
                <router-link
                  :to="{ name: 'AdminConfigCreateCaracterisation' }"
                  class="btn btn-outline-primary btn-xs"
                >
                  <i class="bi bi-plus me-1"></i> Ajouter
                </router-link>
              </div>
            </div>

            <div class="col-auto">
              <!-- Filter -->
              <form>
                <!-- Search -->
                <div class="input-group input-group-merge input-group-flush">
                  <div class="input-group-prepend input-group-text">
                    <i class="bi-search"></i>
                  </div>
                  <input
                    id="datatableWithSearchInput"
                    v-model="searchWord"
                    type="search"
                    class="form-control"
                    placeholder="Search caracterisation"
                    aria-label="Search caracterisation"
                  />
                </div>
                <!-- End Search -->
              </form>
              <!-- End Filter -->
            </div>
          </div>
        </div>
        <div class="card-body datatable-custom position-relative">
          <data-table
            :rows="items"
            :columns="cols"
            :loading="isLoading"
            :sortable="true"
            sortColumn="id"
            sortDirection="desc"
            paginationInfo="De {0} à {1} sur un total de {2}"
            :search="searchWord"
            noDataContent="Pas de resultat"
            class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered"
          >
            <template #name="{ value }">
              <span>
                  <i class="bi-robot bi ms-2" v-if=" !value.filled_by_human"></i> 
                  <i class="bi-person bi ms-2" v-else></i> 
                  {{ value.name }}
              </span>
            </template>
            <template #elements="{ value }">
              <div>
                <span
                  :class="
                    element.is_actif
                      ? 'badge bg-soft-info text-info'
                      : 'badge bg-soft-dark text-gray'
                  "
                  style="margin-bottom: 5px; margin-right: 5px"
                  v-for="(element, i) in value.elements"
                  :key="i"
                >
                  <u
                    :style="{
                      textDecorationLine: !element.is_actif
                        ? 'line-through'
                        : 'none',
                    }"
                  >
                    {{ element.name }} : <b>{{ element.weight }}</b></u
                  >
                </span>
              </div>
            </template>
            <template #action="{ value }">
              <div
                class="btn-group"
                role="group"
                aria-label="Button group with nested dropdown"
              >
                <!-- a href="" class="btn btn-outline-dark btn-xs" title="Voir le résumé"><i class="bi bi-eye"></i></a -->
                <router-link
                  :to="{
                    name: 'AdminConfigShowCaracterisation',
                    params: { id: value.id },
                  }"
                  class="btn btn-outline-dark btn-xs"
                  title="Voir la fiche"
                >
                  <i class="bi bi-eye"></i>
                </router-link>
              </div>
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
// import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  name: "AdminConfigCaracterisations",
  components: {
    SubHeader,
  },
  data() {
    return {
      cols: [
        {
          field: "id",
          title: "",
          sort: false,
          width: "0px",
          type: "number",
          cellRenderer() {
            return "";
          },
        },
        { field: "name", title: "Caractérisation" },
        { field: "coefficient", title: "Coefficient", type: "number" },
        { field: "elements", title: "Element" },
        { field: "type", title: "Type" },
        {
          field: "action",
          title: "Actions",
          sort: false,
          width: "10px",
          headerClass: "justify-center",
          cellClass: "justify-center",
        },
      ],
      searchWord: null,
    };
  },

  computed: {
    ...mapFields("caracterisation/list", {
      isLoading: "isLoading",
      isSuccess: "isSuccess",
      showMessage: "showMessage",
      message: "message",
      items: "items",
    }),
  },

  methods: {
    ...mapActions({
      getCaracterisations: "caracterisation/list/getAll",
      reset: "caracterisation/list/resetData",
    }),
  },
  mounted() {
    this.getCaracterisations();
  },
  unmounted() {
    this.reset();
  },
};
</script>
